import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import {IUser} from "../../../interfaces";

export type GotoResponse = GotoSharedBoardLinkResponse | GotoProjectInviteLinkResponse | ShareProjectBoardGotoResponse | PublicApiGotoResponse;

export type GotoSharedBoardLinkResponse = {
  id: string;
  type: 'shared_board_link';
  token: string;
  data: {
    boardId: string;
    accessLevel: 'viewer' | 'editor';
    userInfo: IUser,
  };
};

export type GotoProjectInviteLinkResponse = {
  "id": string,
  "type": "project_personal_invite_link",
  "token": null,
  "data": {
    "projectId": string,
    "projectOwnerName": string,
    "projectName": string,
    "status": string
  }
}

export interface PublicApiGotoResponse {
  id: string;
  type: 'perare_api_plot_link';
  token: string;
  data: {
    boardId: string;
    projectId: string;
    userInfo: UserInfo;
  }
}

export interface ShareProjectBoardGotoResponse {
  id: string
  type: 'project_board_invite_link'
  token: string
  data: Data
}

export interface Data {
  boardId: string
  projectId: string
  accessLevel: string
  userInfo: UserInfo
}

export interface UserInfo {
  id: number
  uuid: string
  email: string
  name: string
  company: any
  role: any
  phone: any
  locale: any
  isSuperUser: boolean
  disclaimerSubmitted: boolean
  helperSubmitted: boolean
  avatar: string
}


@Injectable({
  providedIn: 'root',
})
export class GotoApiService {
  private _baseUrl: string = `${environment.apiUrl}/api`;

  constructor(private http: HttpClient) {}

  checkGotoPermission(id: string, customPayload?: any) {
    return this.http.post<GotoResponse>(`${this._baseUrl}/goto/${id}`, { id, ...customPayload });
  }
}
